// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SingleOrderRowNew-module__font-s-10___ZDtxT {
  font-size: 10px !important;
}

.SingleOrderRowNew-module__font-s-12___uFqMa {
  font-size: 12px !important;
}

.SingleOrderRowNew-module__font-s-13___S7n8p {
  font-size: 13px !important;
}

.SingleOrderRowNew-module__font-s-14___l33dV {
  font-size: 14px !important;
}

.SingleOrderRowNew-module__font-s-15___Wr95Z {
  font-size: 15px !important;
}

.SingleOrderRowNew-module__font-s-16___MXvoC {
  font-size: 16px !important;
}

.SingleOrderRowNew-module__font-s-18____OQwm {
  font-size: 18px !important;
}

.SingleOrderRowNew-module__font-s-20___lPNGG {
  font-size: 20px !important;
}

.SingleOrderRowNew-module__font-s-22___AC5ES {
  font-size: 22px !important;
}

.SingleOrderRowNew-module__font-s-28___Qal5z {
  font-size: 28px !important;
}

.SingleOrderRowNew-module__font-w-400___2I9yT {
  font-weight: 400 !important;
}

.SingleOrderRowNew-module__font-w-500___Gwjke {
  font-weight: 500 !important;
}

.SingleOrderRowNew-module__font-w-600___I1uaM {
  font-weight: 600 !important;
}

.SingleOrderRowNew-module__font-w-700___Hj6NQ {
  font-weight: 700 !important;
}

.SingleOrderRowNew-module__p-5___DrMla {
  padding: 5px !important;
}

.SingleOrderRowNew-module__p-12___Sny78 {
  padding: 12px !important;
}

.SingleOrderRowNew-module__p-16___gNwOc {
  padding: 16px !important;
}

.SingleOrderRowNew-module__p-30___hXgSE {
  padding: 30px !important;
}

.SingleOrderRowNew-module__p-b-0___Gu2lW {
  padding-bottom: 0 !important;
}

.SingleOrderRowNew-module__p-b-5___Nianu {
  padding-bottom: 5px !important;
}

.SingleOrderRowNew-module__p-b-10___pZfT_ {
  padding-bottom: 10px !important;
}

.SingleOrderRowNew-module__p-b-12___aG8XP {
  padding-bottom: 12px !important;
}

.SingleOrderRowNew-module__p-b-16___ieErB {
  padding-bottom: 16px !important;
}

.SingleOrderRowNew-module__p-b-18___tnlbZ {
  padding-bottom: 18px !important;
}

.SingleOrderRowNew-module__p-b-20___UC5kf {
  padding-bottom: 20px !important;
}

.SingleOrderRowNew-module__p-b-25___JdeTw {
  padding-bottom: 25px !important;
}

.SingleOrderRowNew-module__p-b-30___USWcJ {
  padding-bottom: 30px !important;
}

.SingleOrderRowNew-module__p-b-50___tUzi7 {
  padding-bottom: 50px !important;
}

.SingleOrderRowNew-module__p-t-0___SAuMk {
  padding-top: 0 !important;
}

.SingleOrderRowNew-module__p-t-12___wZmwn {
  padding-top: 12px !important;
}

.SingleOrderRowNew-module__p-t-16___e3q7S {
  padding-top: 16px !important;
}

.SingleOrderRowNew-module__p-t-18___Wu5u0 {
  padding-top: 18px !important;
}

.SingleOrderRowNew-module__p-t-20____XzXU {
  padding-top: 20px !important;
}

.SingleOrderRowNew-module__p-t-30___cOJn7 {
  padding-top: 30px !important;
}

.SingleOrderRowNew-module__p-t-40___Ud0cd {
  padding-top: 40px !important;
}

.SingleOrderRowNew-module__p-t-50___umM2t {
  padding-top: 50px !important;
}

.SingleOrderRowNew-module__p-l-20____nF2q {
  padding-left: 20px !important;
}

.SingleOrderRowNew-module__p-l-30___cWItU {
  padding-left: 30px !important;
}

.SingleOrderRowNew-module__p-l-40___q8tgx {
  padding-left: 40px !important;
}

.SingleOrderRowNew-module__p-r-16___S1yCW {
  padding-right: 16px !important;
}

.SingleOrderRowNew-module__p-r-20___bcnnw {
  padding-right: 20px !important;
}

.SingleOrderRowNew-module__p-r-30___tZjs7 {
  padding-right: 30px !important;
}

.SingleOrderRowNew-module__p-r-50___W7vuN {
  padding-right: 50px !important;
}

.SingleOrderRowNew-module__p-r-60___KYLvz {
  padding-right: 60px !important;
}

.SingleOrderRowNew-module__m-b-1___TNCh8 {
  margin-bottom: 1px !important;
}

.SingleOrderRowNew-module__m-b-2___a7FTO {
  margin-bottom: 2px !important;
}

.SingleOrderRowNew-module__m-b-6___B7d5i {
  margin-bottom: 6px !important;
}

.SingleOrderRowNew-module__m-b-8___R8GyT {
  margin-bottom: 8px !important;
}

.SingleOrderRowNew-module__m-b-10___r39Qm {
  margin-bottom: 10px !important;
}

.SingleOrderRowNew-module__m-b-14___QIkdA {
  margin-bottom: 14px !important;
}

.SingleOrderRowNew-module__m-b-16___Xpx7T {
  margin-bottom: 16px !important;
}

.SingleOrderRowNew-module__m-b-20___pQILE {
  margin-bottom: 20px !important;
}

.SingleOrderRowNew-module__m-b-22___UxjVe {
  margin-bottom: 22px !important;
}

.SingleOrderRowNew-module__m-b-24___xwAiQ {
  margin-bottom: 24px !important;
}

.SingleOrderRowNew-module__m-b-30___JU3F6 {
  margin-bottom: 30px !important;
}

.SingleOrderRowNew-module__m-b-32___d9IUO {
  margin-bottom: 32px !important;
}

.SingleOrderRowNew-module__m-b-40___gPIv3 {
  margin-bottom: 40px !important;
}

.SingleOrderRowNew-module__m-t-2___w5frf {
  margin-top: 2px !important;
}

.SingleOrderRowNew-module__m-t-3___LqZJv {
  margin-top: 3px !important;
}

.SingleOrderRowNew-module__m-t-4___Cve3Z {
  margin-top: 4px !important;
}

.SingleOrderRowNew-module__m-t-5___vlVdL {
  margin-top: 5px !important;
}

.SingleOrderRowNew-module__m-t-8___gNSxs {
  margin-top: 8px !important;
}

.SingleOrderRowNew-module__m-t-10___yEHa0 {
  margin-top: 10px !important;
}

.SingleOrderRowNew-module__m-t-15___uEgko {
  margin-top: 15px !important;
}

.SingleOrderRowNew-module__m-t-16___NammX {
  margin-top: 16px !important;
}

.SingleOrderRowNew-module__m-t-20___jBBk0 {
  margin-top: 20px !important;
}

.SingleOrderRowNew-module__m-t-22___WdeBB {
  margin-top: 22px !important;
}

.SingleOrderRowNew-module__m-t-30___E1HmS {
  margin-top: 30px !important;
}

.SingleOrderRowNew-module__m-t-32___IL91y {
  margin-top: 32px !important;
}

.SingleOrderRowNew-module__m-l-auto___QYB74 {
  margin-left: auto !important;
}

.SingleOrderRowNew-module__m-l-4___zIwN6 {
  margin-left: 4px !important;
}

.SingleOrderRowNew-module__m-l-5___ruLDp {
  margin-left: 5px !important;
}

.SingleOrderRowNew-module__m-l-6___wg3tH {
  margin-left: 6px !important;
}

.SingleOrderRowNew-module__m-l-8___QGL_s {
  margin-left: 8px !important;
}

.SingleOrderRowNew-module__m-l-10___WjtXT {
  margin-left: 10px !important;
}

.SingleOrderRowNew-module__m-l-16___v7Tw4 {
  margin-left: 16px !important;
}

.SingleOrderRowNew-module__m-l-20___w0mqx {
  margin-left: 20px !important;
}

.SingleOrderRowNew-module__m-l-24___h7AYI {
  margin-left: 24px !important;
}

.SingleOrderRowNew-module__m-l-30___T8X_G {
  margin-left: 30px !important;
}

.SingleOrderRowNew-module__m-l-35___gxbrq {
  margin-left: 35px !important;
}

.SingleOrderRowNew-module__m-l-40___jb10h {
  margin-left: 40px !important;
}

.SingleOrderRowNew-module__m-r-8___zGMdQ {
  margin-right: 8px !important;
}

.SingleOrderRowNew-module__m-r-10___fbJFv {
  margin-right: 10px !important;
}

.SingleOrderRowNew-module__m-r-16___G_KoR {
  margin-right: 16px !important;
}

.SingleOrderRowNew-module__m-r-20___mP_n7 {
  margin-right: 20px !important;
}

.SingleOrderRowNew-module__m-r-24___EHexA {
  margin-right: 24px !important;
}

.SingleOrderRowNew-module__m-r-30___nCD2Q {
  margin-right: 30px !important;
}

.SingleOrderRowNew-module__m-r-40___wmA_w {
  margin-right: 40px !important;
}

.SingleOrderRowNew-module__border-r-3___BApHC {
  border-radius: 3px !important;
}

.SingleOrderRowNew-module__border-r-4___SXhLP {
  border-radius: 4px !important;
}

.SingleOrderRowNew-module__border-r-6___peo83 {
  border-radius: 6px !important;
}

.SingleOrderRowNew-module__border-r-10___rKfqv {
  border-radius: 10px !important;
}

.SingleOrderRowNew-module__border-r-12___BXJza {
  border-radius: 12px !important;
}

.SingleOrderRowNew-module__border-r-16___qICfV {
  border-radius: 16px !important;
}

.SingleOrderRowNew-module__border-r-50___MnWxY {
  border-radius: 50% !important;
}

.SingleOrderRowNew-module__primary-border___XALYz {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SingleOrderRowNew-module__primary-border-b___XsT7Q {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SingleOrderRowNew-module__primary-border-t___VwPpb {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SingleOrderRowNew-module__primary-border-l___ijid9 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SingleOrderRowNew-module__primary-border-r___B5R6o {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SingleOrderRowNew-module__secondary-border___tPdkA {
  border: 1px solid #637768;
}

.SingleOrderRowNew-module__secondary-border-b___Lbxnu {
  border-bottom: 1px solid #637768;
}

.SingleOrderRowNew-module__secondary-border-t___z6_Di {
  border-top: 1px solid #637768;
}

.SingleOrderRowNew-module__secondary-border-l___bBk19 {
  border-left: 1px solid #637768;
}

.SingleOrderRowNew-module__secondary-border-r___c0sRT {
  border-right: 1px solid #637768;
}

.SingleOrderRowNew-module__gap-0___RV96k {
  gap: 0 !important;
}

.SingleOrderRowNew-module__gap-2___nhWnd {
  gap: 2px !important;
}

.SingleOrderRowNew-module__gap-4___ABYdj {
  gap: 4px !important;
}

.SingleOrderRowNew-module__gap-5___QECl1 {
  gap: 5px !important;
}

.SingleOrderRowNew-module__gap-6___kTb2k {
  gap: 6px !important;
}

.SingleOrderRowNew-module__gap-8___X7ExJ {
  gap: 8px !important;
}

.SingleOrderRowNew-module__gap-10___OQmbL {
  gap: 10px !important;
}

.SingleOrderRowNew-module__gap-12___z7pjo {
  gap: 12px !important;
}

.SingleOrderRowNew-module__gap-14___YalfB {
  gap: 14px !important;
}

.SingleOrderRowNew-module__gap-16___hI_tQ {
  gap: 16px !important;
}

.SingleOrderRowNew-module__gap-18___M2_vK {
  gap: 18px !important;
}

.SingleOrderRowNew-module__gap-20___ljJNB {
  gap: 20px !important;
}

.SingleOrderRowNew-module__gap-24___ISasM {
  gap: 24px !important;
}

.SingleOrderRowNew-module__gap-26___dUhA_ {
  gap: 26px !important;
}

.SingleOrderRowNew-module__gap-30___BKTXO {
  gap: 30px !important;
}

.SingleOrderRowNew-module__gap-32___Um5BZ {
  gap: 32px !important;
}

.SingleOrderRowNew-module__gap-40___RgAZx {
  gap: 40px !important;
}

.SingleOrderRowNew-module__gap-50___IIxBS {
  gap: 50px !important;
}

.SingleOrderRowNew-module__flex-1___ufguW {
  flex: 1;
}

.SingleOrderRowNew-module__flex-none___Tu1Dz {
  flex: none !important;
}

.SingleOrderRowNew-module__flex-column___Ov09f {
  display: flex;
  flex-direction: column !important;
}

.SingleOrderRowNew-module__flex-row___Nf1Io {
  display: flex;
  flex-direction: row !important;
}

.SingleOrderRowNew-module__vertically-centered___CBYFD {
  display: flex;
  align-items: center !important;
}

.SingleOrderRowNew-module__horizontally-centered___gUH4I {
  display: flex;
  justify-content: center !important;
}

.SingleOrderRowNew-module__horizontally-end___ARnNU {
  display: flex;
  justify-content: end !important;
}

.SingleOrderRowNew-module__vertically-start___hC0Vn {
  display: flex;
  align-items: start !important;
}

.SingleOrderRowNew-module__space-between___Z3xks {
  display: flex;
  justify-content: space-between !important;
}

.SingleOrderRowNew-module__flex-wrap___dUhxS {
  flex-wrap: wrap !important;
}

.SingleOrderRowNew-module__height-100___rXdrG {
  height: 100%;
}

.SingleOrderRowNew-module__width-50____A9ti {
  width: 50% !important;
}

.SingleOrderRowNew-module__width-100___zZ4rl {
  width: 100%;
}

.SingleOrderRowNew-module__cursor-pointer___lwVWW {
  cursor: pointer;
}

.SingleOrderRowNew-module__cursor-not-allowed___ibodX {
  cursor: not-allowed !important;
}

.SingleOrderRowNew-module__absolute-centered___JRGgF {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SingleOrderRowNew-module__absolute___cQ1pw {
  position: absolute;
}

.SingleOrderRowNew-module__relative___od9Ow {
  position: relative;
}

.SingleOrderRowNew-module__fixed___G6mma {
  position: fixed;
}

.SingleOrderRowNew-module__visible___ycpQv {
  opacity: 1;
}

.SingleOrderRowNew-module__invisible___iekAK {
  opacity: 0;
}

.SingleOrderRowNew-module__col-90___vUu_M {
  width: 90% !important;
}

.SingleOrderRowNew-module__col-auto___QOjAV {
  width: auto !important;
}

.SingleOrderRowNew-module__medical-tabs___C17XF {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SingleOrderRowNew-module__medical-table-new___ENW2u {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SingleOrderRowNew-module__medical-table-new___ENW2u:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SingleOrderRowNew-module__medical-table-new___ENW2u::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SingleOrderRowNew-module__medical-table-new___ENW2u::-webkit-scrollbar-track {
  display: none;
}
.SingleOrderRowNew-module__medical-table-new___ENW2u.SingleOrderRowNew-module__no-pagination___K2u7O {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SingleOrderRowNew-module__medical-table-new___ENW2u.SingleOrderRowNew-module__no-pagination___K2u7O:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SingleOrderRowNew-module__medical-table-new___ENW2u.SingleOrderRowNew-module__no-pagination___K2u7O::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SingleOrderRowNew-module__medical-table-new___ENW2u.SingleOrderRowNew-module__no-pagination___K2u7O::-webkit-scrollbar-track {
  display: none;
}

.SingleOrderRowNew-module__medical-table-empty___bVIdo {
  padding: 14px 40px !important;
}

.SingleOrderRowNew-module__icon-btn___luyQ6 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SingleOrderRowNew-module__search-icon___Oy5yv {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SingleOrderRowNew-module__disable-select___uQ7B9 {
  user-select: none;
}

.SingleOrderRowNew-module__break-word___nRH4L {
  word-break: break-word;
}

.SingleOrderRowNew-module__popup-clear-btn___Bi_KA {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SingleOrderRowNew-module__scroll-m-b-20___ggTXR {
  scroll-margin-bottom: 20px;
}

.SingleOrderRowNew-module__row___Hga1f {
  display: flex;
  height: 53px;
  color: #375844;
}
.SingleOrderRowNew-module__row___Hga1f .SingleOrderRowNew-module__textContainer___cBnK9 {
  flex: 1;
}
.SingleOrderRowNew-module__row___Hga1f .SingleOrderRowNew-module__select___X3FvP {
  width: 205px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/rows/SingleOrderRowNew/SingleOrderRowNew.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,YAAA;EACA,cAAA;AA8pBF;AA5pBE;EACE,OAAA;AA8pBJ;AA3pBE;EACE,YAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.row {\n  display: flex;\n  height: 53px;\n  color: get-color(greenNew, dark);\n\n  .textContainer {\n    flex: 1;\n  }\n\n  .select {\n    width: 205px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SingleOrderRowNew-module__font-s-10___ZDtxT`,
	"fontS12": `SingleOrderRowNew-module__font-s-12___uFqMa`,
	"fontS13": `SingleOrderRowNew-module__font-s-13___S7n8p`,
	"fontS14": `SingleOrderRowNew-module__font-s-14___l33dV`,
	"fontS15": `SingleOrderRowNew-module__font-s-15___Wr95Z`,
	"fontS16": `SingleOrderRowNew-module__font-s-16___MXvoC`,
	"fontS18": `SingleOrderRowNew-module__font-s-18____OQwm`,
	"fontS20": `SingleOrderRowNew-module__font-s-20___lPNGG`,
	"fontS22": `SingleOrderRowNew-module__font-s-22___AC5ES`,
	"fontS28": `SingleOrderRowNew-module__font-s-28___Qal5z`,
	"fontW400": `SingleOrderRowNew-module__font-w-400___2I9yT`,
	"fontW500": `SingleOrderRowNew-module__font-w-500___Gwjke`,
	"fontW600": `SingleOrderRowNew-module__font-w-600___I1uaM`,
	"fontW700": `SingleOrderRowNew-module__font-w-700___Hj6NQ`,
	"p5": `SingleOrderRowNew-module__p-5___DrMla`,
	"p12": `SingleOrderRowNew-module__p-12___Sny78`,
	"p16": `SingleOrderRowNew-module__p-16___gNwOc`,
	"p30": `SingleOrderRowNew-module__p-30___hXgSE`,
	"pB0": `SingleOrderRowNew-module__p-b-0___Gu2lW`,
	"pB5": `SingleOrderRowNew-module__p-b-5___Nianu`,
	"pB10": `SingleOrderRowNew-module__p-b-10___pZfT_`,
	"pB12": `SingleOrderRowNew-module__p-b-12___aG8XP`,
	"pB16": `SingleOrderRowNew-module__p-b-16___ieErB`,
	"pB18": `SingleOrderRowNew-module__p-b-18___tnlbZ`,
	"pB20": `SingleOrderRowNew-module__p-b-20___UC5kf`,
	"pB25": `SingleOrderRowNew-module__p-b-25___JdeTw`,
	"pB30": `SingleOrderRowNew-module__p-b-30___USWcJ`,
	"pB50": `SingleOrderRowNew-module__p-b-50___tUzi7`,
	"pT0": `SingleOrderRowNew-module__p-t-0___SAuMk`,
	"pT12": `SingleOrderRowNew-module__p-t-12___wZmwn`,
	"pT16": `SingleOrderRowNew-module__p-t-16___e3q7S`,
	"pT18": `SingleOrderRowNew-module__p-t-18___Wu5u0`,
	"pT20": `SingleOrderRowNew-module__p-t-20____XzXU`,
	"pT30": `SingleOrderRowNew-module__p-t-30___cOJn7`,
	"pT40": `SingleOrderRowNew-module__p-t-40___Ud0cd`,
	"pT50": `SingleOrderRowNew-module__p-t-50___umM2t`,
	"pL20": `SingleOrderRowNew-module__p-l-20____nF2q`,
	"pL30": `SingleOrderRowNew-module__p-l-30___cWItU`,
	"pL40": `SingleOrderRowNew-module__p-l-40___q8tgx`,
	"pR16": `SingleOrderRowNew-module__p-r-16___S1yCW`,
	"pR20": `SingleOrderRowNew-module__p-r-20___bcnnw`,
	"pR30": `SingleOrderRowNew-module__p-r-30___tZjs7`,
	"pR50": `SingleOrderRowNew-module__p-r-50___W7vuN`,
	"pR60": `SingleOrderRowNew-module__p-r-60___KYLvz`,
	"mB1": `SingleOrderRowNew-module__m-b-1___TNCh8`,
	"mB2": `SingleOrderRowNew-module__m-b-2___a7FTO`,
	"mB6": `SingleOrderRowNew-module__m-b-6___B7d5i`,
	"mB8": `SingleOrderRowNew-module__m-b-8___R8GyT`,
	"mB10": `SingleOrderRowNew-module__m-b-10___r39Qm`,
	"mB14": `SingleOrderRowNew-module__m-b-14___QIkdA`,
	"mB16": `SingleOrderRowNew-module__m-b-16___Xpx7T`,
	"mB20": `SingleOrderRowNew-module__m-b-20___pQILE`,
	"mB22": `SingleOrderRowNew-module__m-b-22___UxjVe`,
	"mB24": `SingleOrderRowNew-module__m-b-24___xwAiQ`,
	"mB30": `SingleOrderRowNew-module__m-b-30___JU3F6`,
	"mB32": `SingleOrderRowNew-module__m-b-32___d9IUO`,
	"mB40": `SingleOrderRowNew-module__m-b-40___gPIv3`,
	"mT2": `SingleOrderRowNew-module__m-t-2___w5frf`,
	"mT3": `SingleOrderRowNew-module__m-t-3___LqZJv`,
	"mT4": `SingleOrderRowNew-module__m-t-4___Cve3Z`,
	"mT5": `SingleOrderRowNew-module__m-t-5___vlVdL`,
	"mT8": `SingleOrderRowNew-module__m-t-8___gNSxs`,
	"mT10": `SingleOrderRowNew-module__m-t-10___yEHa0`,
	"mT15": `SingleOrderRowNew-module__m-t-15___uEgko`,
	"mT16": `SingleOrderRowNew-module__m-t-16___NammX`,
	"mT20": `SingleOrderRowNew-module__m-t-20___jBBk0`,
	"mT22": `SingleOrderRowNew-module__m-t-22___WdeBB`,
	"mT30": `SingleOrderRowNew-module__m-t-30___E1HmS`,
	"mT32": `SingleOrderRowNew-module__m-t-32___IL91y`,
	"mLAuto": `SingleOrderRowNew-module__m-l-auto___QYB74`,
	"mL4": `SingleOrderRowNew-module__m-l-4___zIwN6`,
	"mL5": `SingleOrderRowNew-module__m-l-5___ruLDp`,
	"mL6": `SingleOrderRowNew-module__m-l-6___wg3tH`,
	"mL8": `SingleOrderRowNew-module__m-l-8___QGL_s`,
	"mL10": `SingleOrderRowNew-module__m-l-10___WjtXT`,
	"mL16": `SingleOrderRowNew-module__m-l-16___v7Tw4`,
	"mL20": `SingleOrderRowNew-module__m-l-20___w0mqx`,
	"mL24": `SingleOrderRowNew-module__m-l-24___h7AYI`,
	"mL30": `SingleOrderRowNew-module__m-l-30___T8X_G`,
	"mL35": `SingleOrderRowNew-module__m-l-35___gxbrq`,
	"mL40": `SingleOrderRowNew-module__m-l-40___jb10h`,
	"mR8": `SingleOrderRowNew-module__m-r-8___zGMdQ`,
	"mR10": `SingleOrderRowNew-module__m-r-10___fbJFv`,
	"mR16": `SingleOrderRowNew-module__m-r-16___G_KoR`,
	"mR20": `SingleOrderRowNew-module__m-r-20___mP_n7`,
	"mR24": `SingleOrderRowNew-module__m-r-24___EHexA`,
	"mR30": `SingleOrderRowNew-module__m-r-30___nCD2Q`,
	"mR40": `SingleOrderRowNew-module__m-r-40___wmA_w`,
	"borderR3": `SingleOrderRowNew-module__border-r-3___BApHC`,
	"borderR4": `SingleOrderRowNew-module__border-r-4___SXhLP`,
	"borderR6": `SingleOrderRowNew-module__border-r-6___peo83`,
	"borderR10": `SingleOrderRowNew-module__border-r-10___rKfqv`,
	"borderR12": `SingleOrderRowNew-module__border-r-12___BXJza`,
	"borderR16": `SingleOrderRowNew-module__border-r-16___qICfV`,
	"borderR50": `SingleOrderRowNew-module__border-r-50___MnWxY`,
	"primaryBorder": `SingleOrderRowNew-module__primary-border___XALYz`,
	"primaryBorderB": `SingleOrderRowNew-module__primary-border-b___XsT7Q`,
	"primaryBorderT": `SingleOrderRowNew-module__primary-border-t___VwPpb`,
	"primaryBorderL": `SingleOrderRowNew-module__primary-border-l___ijid9`,
	"primaryBorderR": `SingleOrderRowNew-module__primary-border-r___B5R6o`,
	"secondaryBorder": `SingleOrderRowNew-module__secondary-border___tPdkA`,
	"secondaryBorderB": `SingleOrderRowNew-module__secondary-border-b___Lbxnu`,
	"secondaryBorderT": `SingleOrderRowNew-module__secondary-border-t___z6_Di`,
	"secondaryBorderL": `SingleOrderRowNew-module__secondary-border-l___bBk19`,
	"secondaryBorderR": `SingleOrderRowNew-module__secondary-border-r___c0sRT`,
	"gap0": `SingleOrderRowNew-module__gap-0___RV96k`,
	"gap2": `SingleOrderRowNew-module__gap-2___nhWnd`,
	"gap4": `SingleOrderRowNew-module__gap-4___ABYdj`,
	"gap5": `SingleOrderRowNew-module__gap-5___QECl1`,
	"gap6": `SingleOrderRowNew-module__gap-6___kTb2k`,
	"gap8": `SingleOrderRowNew-module__gap-8___X7ExJ`,
	"gap10": `SingleOrderRowNew-module__gap-10___OQmbL`,
	"gap12": `SingleOrderRowNew-module__gap-12___z7pjo`,
	"gap14": `SingleOrderRowNew-module__gap-14___YalfB`,
	"gap16": `SingleOrderRowNew-module__gap-16___hI_tQ`,
	"gap18": `SingleOrderRowNew-module__gap-18___M2_vK`,
	"gap20": `SingleOrderRowNew-module__gap-20___ljJNB`,
	"gap24": `SingleOrderRowNew-module__gap-24___ISasM`,
	"gap26": `SingleOrderRowNew-module__gap-26___dUhA_`,
	"gap30": `SingleOrderRowNew-module__gap-30___BKTXO`,
	"gap32": `SingleOrderRowNew-module__gap-32___Um5BZ`,
	"gap40": `SingleOrderRowNew-module__gap-40___RgAZx`,
	"gap50": `SingleOrderRowNew-module__gap-50___IIxBS`,
	"flex1": `SingleOrderRowNew-module__flex-1___ufguW`,
	"flexNone": `SingleOrderRowNew-module__flex-none___Tu1Dz`,
	"flexColumn": `SingleOrderRowNew-module__flex-column___Ov09f`,
	"flexRow": `SingleOrderRowNew-module__flex-row___Nf1Io`,
	"verticallyCentered": `SingleOrderRowNew-module__vertically-centered___CBYFD`,
	"horizontallyCentered": `SingleOrderRowNew-module__horizontally-centered___gUH4I`,
	"horizontallyEnd": `SingleOrderRowNew-module__horizontally-end___ARnNU`,
	"verticallyStart": `SingleOrderRowNew-module__vertically-start___hC0Vn`,
	"spaceBetween": `SingleOrderRowNew-module__space-between___Z3xks`,
	"flexWrap": `SingleOrderRowNew-module__flex-wrap___dUhxS`,
	"height100": `SingleOrderRowNew-module__height-100___rXdrG`,
	"width50": `SingleOrderRowNew-module__width-50____A9ti`,
	"width100": `SingleOrderRowNew-module__width-100___zZ4rl`,
	"cursorPointer": `SingleOrderRowNew-module__cursor-pointer___lwVWW`,
	"cursorNotAllowed": `SingleOrderRowNew-module__cursor-not-allowed___ibodX`,
	"absoluteCentered": `SingleOrderRowNew-module__absolute-centered___JRGgF`,
	"absolute": `SingleOrderRowNew-module__absolute___cQ1pw`,
	"relative": `SingleOrderRowNew-module__relative___od9Ow`,
	"fixed": `SingleOrderRowNew-module__fixed___G6mma`,
	"visible": `SingleOrderRowNew-module__visible___ycpQv`,
	"invisible": `SingleOrderRowNew-module__invisible___iekAK`,
	"col90": `SingleOrderRowNew-module__col-90___vUu_M`,
	"colAuto": `SingleOrderRowNew-module__col-auto___QOjAV`,
	"medicalTabs": `SingleOrderRowNew-module__medical-tabs___C17XF`,
	"medicalTableNew": `SingleOrderRowNew-module__medical-table-new___ENW2u`,
	"noPagination": `SingleOrderRowNew-module__no-pagination___K2u7O`,
	"medicalTableEmpty": `SingleOrderRowNew-module__medical-table-empty___bVIdo`,
	"iconBtn": `SingleOrderRowNew-module__icon-btn___luyQ6`,
	"searchIcon": `SingleOrderRowNew-module__search-icon___Oy5yv`,
	"disableSelect": `SingleOrderRowNew-module__disable-select___uQ7B9`,
	"breakWord": `SingleOrderRowNew-module__break-word___nRH4L`,
	"popupClearBtn": `SingleOrderRowNew-module__popup-clear-btn___Bi_KA`,
	"scrollMB20": `SingleOrderRowNew-module__scroll-m-b-20___ggTXR`,
	"row": `SingleOrderRowNew-module__row___Hga1f`,
	"textContainer": `SingleOrderRowNew-module__textContainer___cBnK9`,
	"select": `SingleOrderRowNew-module__select___X3FvP`
};
module.exports = ___CSS_LOADER_EXPORT___;
